export interface CodecSelection {
  mimeType: string | undefined
  bitrate: number
}

export function selectCodec(): CodecSelection {
  const userAgent = navigator.userAgent
  const isSafari =
    /^((?!chrome|android).)*safari/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)
  // Prefer compact codecs for upload transport; keep WAV as final compatibility fallback.
  const preferredMimeTypes = isSafari
    ? ['audio/mp4', 'audio/aac', 'audio/webm;codecs=opus', 'audio/webm', 'audio/ogg', 'audio/wav']
    : ['audio/webm;codecs=opus', 'audio/webm', 'audio/ogg', 'audio/mp4', 'audio/aac', 'audio/wav']
  const mimeType = preferredMimeTypes.find((type) => MediaRecorder.isTypeSupported(type))
  return { mimeType, bitrate: 128_000 }
}
